import { render, staticRenderFns } from "./IframeVideoForm.vue?vue&type=template&id=b3afbf52&scoped=true&"
import script from "./IframeVideoForm.vue?vue&type=script&lang=ts&"
export * from "./IframeVideoForm.vue?vue&type=script&lang=ts&"
import style0 from "./IframeVideoForm.vue?vue&type=style&index=0&id=b3afbf52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3afbf52",
  null
  
)

export default component.exports